<app-navbar></app-navbar>
<main [@routing]="outletRef.isActivated ? outletRef.activatedRoute : ''">
  <router-outlet #outletRef="outlet"></router-outlet>
</main>
<app-footer></app-footer>

<div class="holder" *ngIf="loaderService.isLoading | async">
  <div class="loader"><img src="../assets/images/logo.png" alt="logo" /></div>
</div>
